module.exports = __webpack_public_path__ + "static/media/ball.3d793730.png";